import EnvironmentConfig from '../interfaces/EnvironmentConfig';
import developmentConfig from './development';
import e2eQaConfigs from './e2eqa';
import productionConfigs from './production';
import qaConfigs from './qa';
import saravanaConfigs from './saravana';

type ConfigMap = { [env: string]: EnvironmentConfig };

const configsMap: ConfigMap = {
  qa: qaConfigs,
  dev: developmentConfig,
  e2eqa: e2eQaConfigs,
  production: productionConfigs,
  saravana: saravanaConfigs,
};

const getEnvConfigs = () => {
  const currentEnv = process.env.REACT_APP_DEPLOY_ENV || 'dev';

    if (!currentEnv || !configsMap[currentEnv]) {
        throw new Error('No Env Found')
    }

    let localConfig = {}
    try {
      localConfig = require(`./local-${currentEnv}.json`);
    } catch (e) {
      // Local config file not found, ignoring
      console.log('Local config file not found, ignoring')
    }

    return { ...configsMap[currentEnv], ...localConfig }
}

export default getEnvConfigs();
